import { DestroyRef, Injectable, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { distinctUntilChanged, filter, map } from 'rxjs';
import { LocaleStateService } from '@app/common/locale/application/services/locale-state.service';
import { Locale } from '@app/common/locale/domain/entities/locale';
import { Language } from '@app/common/locale/domain/entities/language.enum';
import { AngularI18nService } from 'common/data/i18n/services/angular-i18n.service';

/**
 * Unico escritor del idioma de la UI: lo deriva del locale activo (LocaleStateService, la misma
 * fuente de X-Language). Se instancia en el APP_INITIALIZER, asi UI y header nunca divergen.
 */
@Injectable({ providedIn: 'root' })
export class LocaleUiSyncService {
    public constructor() {
        const i18n: AngularI18nService = inject(AngularI18nService);

        inject(LocaleStateService)
            .locale$.pipe(
                filter((locale: Locale | null): locale is Locale => locale !== null),
                map((locale: Locale): Language => locale.toLanguage()),
                distinctUntilChanged(),
                takeUntilDestroyed(inject(DestroyRef)),
            )
            .subscribe((lang: Language): void => i18n.applyUiLang(lang));
    }
}
